// ============================================================
// DashboardGrid Component
// ============================================================
// CSS Grid wrapper for dashboard layouts.

import { Box } from '@mui/material';

export function DashboardGrid({ children, columns = { xs: 1, sm: 2, md: 3, lg: 4 }, gap = 3, sx = {} }) {
  const getGridTemplateColumns = () => {
    if (typeof columns === 'number') {
      return `repeat(${columns}, 1fr)`;
    }

    // Convert MUI breakpoint object to grid-template-columns
    const result = {};
    Object.entries(columns).forEach(([breakpoint, cols]) => {
      result[breakpoint] = `repeat(${cols}, 1fr)`;
    });
    return result;
  };

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: getGridTemplateColumns(),
        gap,
        mb: 4,
        ...sx,
      }}
    >
      {children}
    </Box>
  );
}
